import SpecSelector from './SpecSelector';

export { SpecSelector as default };
